import { Capacitor } from '@capacitor/core';

/**
 * Fire a medium-impact haptic on native platforms.
 * No-op on web — safe to call anywhere.
 */
export async function hapticMedium(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    // silently ignore on web or if plugin unavailable
  }
}

/**
 * Fire a light selection haptic on native platforms.
 * Ideal for picker/list selections. No-op on web.
 */
export async function hapticSelection(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { Haptics } = await import('@capacitor/haptics');
    await Haptics.selectionStart();
  } catch {
    // silently ignore
  }
}
